module.exports = __webpack_public_path__ + "img/undraw_setup_analytics.08a9425b.svg";